import { toast, cn } from "@eisox/design-system";
import { Scanner } from "@yudiel/react-qr-scanner";

import { m } from "~/paraglide/messages";

/** The library finder is 1:1, a fixed square keeps the camera from filling the whole dialog on mobile. */
const SCANNER_SIZE_PX = 168;

interface MacQrScannerProps {
  paused: boolean;
  className?: string;
  onScan: (raw: string) => void;
}

export const MacQrScanner: React.FC<MacQrScannerProps> = ({ paused, className, onScan }) => {
  const handleScan = (detectedCodes: { rawValue: string }[]) => {
    const raw = detectedCodes[0]?.rawValue;
    if (raw) onScan(raw);
  };

  const handleError = (error: unknown) => {
    const name = error instanceof DOMException ? error.name : "";
    const denied = name === "NotAllowedError" || name === "PermissionDeniedError";
    toast.error(denied ? m.scanner_denied() : m.scanner_error());
  };

  return (
    <div className={cn("flex w-full justify-center", className)} aria-label={m.scanner_title()}>
      <div
        className="rounded-md relative shrink-0 overflow-hidden"
        style={{ width: SCANNER_SIZE_PX, height: SCANNER_SIZE_PX }}
      >
        <Scanner
          paused={paused}
          onScan={handleScan}
          onError={handleError}
          constraints={{ facingMode: "environment" }}
          components={{ finder: true, torch: false, onOff: false, zoom: false }}
          styles={{
            container: { width: SCANNER_SIZE_PX, height: SCANNER_SIZE_PX, position: "relative", overflow: "hidden" },
            video: { width: "100%", height: "100%", objectFit: "cover" },
          }}
        />
      </div>
    </div>
  );
};

MacQrScanner.displayName = "MacQrScanner";
